;(function search($) {
    var $form = $('form');
    $form.on('selectmenuchange', '.Sort-wrap', function () {
        $form.submit();
    });
}(jQuery));